module.exports = __webpack_public_path__ + "img/14.9bed20fb.jpg";